
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { EditSubscriptionDialog } from "@/components/subscriptions/edit-subscription-dialog"
import { DeleteSubscriptionDialog } from "@/components/subscriptions/delete-subscription-dialog"
import { MoreHorizontalIcon, PencilIcon, TrashIcon } from "lucide-react"
import { mockSubscriptions } from "@/lib/mock-data"

export function SubscriptionTable() {
  const { t } = useTranslation()
  const [editingSubscription, setEditingSubscription] = useState<string | null>(null)
  const [deletingSubscription, setDeletingSubscription] = useState<string | null>(null)

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t("subscriptions.name")}</TableHead>
            <TableHead>{t("subscriptions.price")}</TableHead>
            <TableHead>{t("subscriptions.duration")}</TableHead>
            <TableHead>{t("subscriptions.status")}</TableHead>
            <TableHead className="text-right">{t("common.actions")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {mockSubscriptions.map((subscription) => (
            <TableRow key={subscription.id}>
              <TableCell className="font-medium">{subscription.name}</TableCell>
              <TableCell>${subscription.price.toFixed(2)}</TableCell>
              <TableCell>
                {subscription.duration} {t(`subscriptions.${subscription.durationType}`)}
              </TableCell>
              <TableCell>
                <Badge variant={subscription.status === "active" ? "default" : "secondary"}>
                  {subscription.status === "active" ? t("subscriptions.active") : t("subscriptions.inactive")}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="icon">
                      <MoreHorizontalIcon className="h-4 w-4" />
                      <span className="sr-only">{t("common.actions")}</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => setEditingSubscription(subscription.id)}>
                      <PencilIcon className="h-4 w-4 mr-2" />
                      {t("common.edit")}
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => setDeletingSubscription(subscription.id)}>
                      <TrashIcon className="h-4 w-4 mr-2" />
                      {t("common.delete")}
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {editingSubscription && (
        <EditSubscriptionDialog
          subscriptionId={editingSubscription}
          open={!!editingSubscription}
          onOpenChange={() => setEditingSubscription(null)}
        />
      )}

      {deletingSubscription && (
        <DeleteSubscriptionDialog
          subscriptionId={deletingSubscription}
          open={!!deletingSubscription}
          onOpenChange={() => setDeletingSubscription(null)}
        />
      )}
    </>
  )
}
